import { Skeleton } from "@components/common/skeleton/skeleton";
import { FunctionComponent } from "react";

interface LogoSkeletonProps {
    expanded: boolean;
}

export const LogoSkeleton: FunctionComponent<LogoSkeletonProps> = ({ expanded }) => {
    return (
        <div className={expanded ? "px-2" : "size-8"}>
            {expanded ? <Skeleton className="h-7 w-36" rounded="md" /> : <Skeleton className="size-8" rounded="md" />}
        </div>
    );
};
